import React from 'react';
import { useTranslation } from 'react-i18next';
import CalculatorIcon from '../../../../ASUPhotos/icons/me3_Calculator.svg';

function ModalMathReq(props) {
  const { t } = useTranslation();
  const { degree } = { ...props };
  const calculatorIcon = {
    height: '15px',
    width: '15px',
  };

  return (
    <div className="modal-math-req-container">
      <img
        aria-hidden
        alt="calculator-icon"
        src={CalculatorIcon}
        style={calculatorIcon}
        data-cy="calculator-icon"
        width="800"
        height="400"
      />
      <p className="modal-math-req copy-text">{t('First Math Required: ')}</p>
      <p className="modal-math-req dynamic-text">{degree.firstMathReq}</p>
    </div>
  );
}

export default ModalMathReq;
